module.exports = __webpack_public_path__ + "static/media/vibrant-3.60a36b7d.png";